// import axios from "axios";
import React, { useEffect, useState } from "react";
import { Container, Grid } from "@mui/material";
import PhysicsOffRoutine from "../PhysicsOffRoutine/PhysicsOffRoutine";
// import { Box } from "@mui/system";

const AvailablePhysicsOff = () => {
  const [routinedata, setRouineData] = useState([]);

  useEffect(() => {
    fetch("/physicsoff.json")
      .then((res) => res.json())
      .then((data) => setRouineData(data));
  }, []);

  return (
    <Container fluid="true" sx={{ margin: "0 auto" }}>
      <Grid container spacing={2} sx={{ margin: "0 0PX" }}>
        {routinedata.map((routine) => (
          <PhysicsOffRoutine routine={routine}></PhysicsOffRoutine>
        ))}
      </Grid>
    </Container>
  );
};

export default AvailablePhysicsOff;
